import {
  enableProdMode,
  inject,
  Injectable,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  provideTranslateService
} from '@ngx-translate/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { AppConfig, initConfig } from './app/app.config';
import { provideRouter, withComponentInputBinding, withDebugTracing, withInMemoryScrolling } from '@angular/router';
import { APP_ROUTES } from './app/app-routes';
import { MAT_DATE_LOCALE } from '@angular/material/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
import LocaleEn from '@angular/common/locales/en';
// eslint-disable-next-line @typescript-eslint/naming-convention
import LocaleFr from '@angular/common/locales/fr';
import { PfAngularOauth2OidcInterceptor, PfAngularOauth2OidcProvider } from '@bnpp-pf/pf-angular-oauth2-oidc';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { logInterceptor } from './app/core/interceptors/log.interceptor';

// to use the local format like Date, Currency...
registerLocaleData(LocaleEn, 'en');
registerLocaleData(LocaleFr, 'fr');

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return `[Missing translation for key:  ${params.key}]`;
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      APP_ROUTES,
      withDebugTracing(),
      withComponentInputBinding(),
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'fr',
      lang: localStorage.getItem('lang') ?? 'fr',
      missingTranslationHandler: MyMissingTranslationHandler
    }),
    AppConfig,
    provideAppInitializer(() => {
      const initializerFn = initConfig(inject(AppConfig));
      return initializerFn();
    }),
    provideHttpClient(withXhr(), withInterceptors([PfAngularOauth2OidcInterceptor, logInterceptor])),
    ...PfAngularOauth2OidcProvider
  ]
}).catch(err => console.log(err));
